module.exports = __webpack_public_path__ + "media/images/flags/32/Italy-d3bc8f8285c2461dddffa46528d4d40e.png";